import axios from 'axios';
import {generateDefaultOptions} from './config';
import {ENV} from '../../envirement';
import {store} from '../store';

import {validateAndRefreshTokens} from './auth/auth';


const customAxios = axios.create({
    baseURL: `https://nuins.io/syws-proxy/api/${ENV}`,
    headers: {}
});


const requestHandler = async request => {
    // Token will be dynamic so we can use any app-specific way to always   
    // fetch the new token before making the call
     
    try{
        await store.dispatch(validateAndRefreshTokens());
    } catch (error) {
        console.log(error);
    }

    const {auth} = store.getState();

    const defaultOptions = generateDefaultOptions(auth);

    //console.log(request.headers);

    request.headers ={...defaultOptions.headers, ...request.headers};
    
    return request;
};

const responseHandler = response => {
    if (response.status === 401) {
    }

    return response;
};

const errorHandler = error => {
    return Promise.reject(error);
};

customAxios.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

customAxios.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
 );

 export default customAxios;